import classes from "../ThousandPropertiesNewRails.module.scss";
import CompactInventoryCard from "@Components/CompactInventoryCard";
import DefaultCompactInventoryCard from "@Pages/Home/components/HomepageCollectionSkeleton/DefaultCompactInventoryCard";
import Button from "@Components/Button";
import HorizontalScroll from "@Components/HorizontalScroll";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { CollectionItem } from "../types";
import wrapperHOC from "@Utils/wrapperHOC";
import { APP_PAGE } from "@Utils/webApputils/analyticEvents";
import useTranslationHook from "hooks/useTranslationHook";

interface ContentRendererProps {
  isRequestActive: boolean;
  collectionState: CollectionItem[] | "exploreMore";
  displayCollection: CollectionItem[] | "exploreMore";
  title: string;
  gtagEventAction: string;
  gtagEventCategory: string;
  isDesktop: boolean;
  activePillCanonical: string | null;
  handleExploreMore: () => void;
  isWhitelabel: boolean;
}

const ContentRenderer: React.FC<ContentRendererProps> = ({
  isRequestActive,
  collectionState,
  displayCollection,
  title,
  gtagEventAction,
  gtagEventCategory,
  isDesktop,
  activePillCanonical,
  handleExploreMore,
  isWhitelabel,
}) => {
  const { t } = useTranslationHook();
  if (isRequestActive) {
    return (
      <HorizontalScroll
        key={activePillCanonical}
        className={formatClassNames(classes.horizontalScrollCr, isDesktop && classes.desktopCr)}
      >
        {Array.isArray(displayCollection) &&
          displayCollection.map((item, i) => (
            <CompactInventoryCard
              dataTestId={title}
              item={item}
              key={`${item?.id || "asd"}-${i}`}
              isRequestActive={isRequestActive}
              showIcons
              gtagEventAction={gtagEventAction}
              gtagEventCategory={gtagEventCategory}
              isDesktop={isDesktop}
              screenName={APP_PAGE.HOME}
            />
          ))}
        {Array.from({ length: 8 }).map((_, index) => (
          <DefaultCompactInventoryCard key={index} />
        ))}
      </HorizontalScroll>
    );
  }

  if (collectionState === "exploreMore") {
    return (
      <div className={classes.explorePropertiesButtonContainer}>
        <Button
          onClick={handleExploreMore}
          variant={isWhitelabel ? "whiteLabel_primary" : "primary"}
          type="button"
          className={classes.explorePropertiesButton}
          dataTestId="explore-properties-button"
        >
          {t("home.components.thousandpropertiesnewrails.exploremoreproperties")}
        </Button>
      </div>
    );
  }

  if (Array.isArray(collectionState) && collectionState.length > 0) {
    return (
      <HorizontalScroll
        key={activePillCanonical}
        dataTestId={title}
        showControls={isDesktop}
        className={formatClassNames(classes.horizontalScrollCr, isDesktop && classes.desktopCr)}
        bgColor="white"
      >
        {Array.isArray(displayCollection) &&
          displayCollection.map((item, i) => (
            <CompactInventoryCard
              dataTestId={title}
              item={item}
              key={`${item?.id || "asd"}-${i}`}
              isRequestActive={isRequestActive}
              parentCanonicalName={i === displayCollection.length - 1 ? activePillCanonical : null}
              showIcons
              gtagEventAction={gtagEventAction}
              gtagEventCategory={gtagEventCategory}
              isDesktop={isDesktop}
              screenName={APP_PAGE.HOME}
            />
          ))}
      </HorizontalScroll>
    );
  }

  return null;
};

export default wrapperHOC(ContentRenderer, {
  componentName: "ContentRenderer-thousandproperty",
  showForChina: true,
});
